import theme from '@/style';
import LazyImage from '@/components/basic/image';
import {goTo} from '@/utils';
import React from 'react';
import {View} from 'react-native';
import {useInnerStyle} from '../home.hooks';
import {useTranslation} from 'react-i18next';
import {homePage} from '@/config';
import SpinActualContent from '@/pages/spin-actual';
import {useModalManager} from '@basicComponents/sequential-modal/ModalManagerProvider';

const HomeGoldArea: React.FC = () => {
  const {i18n} = useTranslation();
  const {
    size: {screenWidth},
  } = useInnerStyle();
  const {showModal} = useModalManager();

  const list = [
    {
      bgImgUrl: require('@/assets/imgs/home/gold-promotions.png'),
      moduleName: i18n.t('home.label.promotions'),
      jumpHandler() {
        goTo('PromotionsV2', {tabKey: 'promotion'});
      },
    },
    {
      bgImgUrl: require('@/assets/imgs/home/gold-invite.png'),
      moduleName: i18n.t('home.label.earn'),
      jumpHandler() {
        goTo('Invitation');
      },
    },
    // {
    //   bgImgUrl: require('@/assets/imgs/home/gold-agency.png'),
    //   moduleName: i18n.t('home.label.agency'),
    //   jumpHandler() {
    //     const user = JSON.parse(localStorage.getItem('user') || '{}');
    //     if (user.isAgent === 1) {
    //       goTo('ProxyHome');
    //     } else {
    //       toAgentApply();
    //     }
    //   },
    // },
    {
      bgImgUrl: require('@/assets/icons/home/spin-actual.png'),
      moduleName: i18n.t('home.label.spinActual'),
      jumpHandler() {
        showModal({
          id: 'spin-actual',
          modals: [<SpinActualContent />],
          transitionType: 'scale',
          closeOnClickOutside: true,
        });
      },
      type: 'spin-actual',
    },
    {
      bgImgUrl: require('@/assets/imgs/home/gold-chat.png'),
      moduleName: i18n.t('home.label.chat'),
      jumpHandler: async () => {
        // if (!token) {
        //   goTo('Login', {
        //     backPage: homePage,
        //     // sucessPage: homePage,
        //     // sucessPageParams: {
        //     //   screen: 'Chat',
        //     // },
        //     sucessPage: 'Chat',
        //   });
        //   return;
        // }
        // let customers: RechargeCustomerItem[] = [];
        // try {
        //   customers = await getRechargeCustomers();
        // } catch (error) {
        //   console.log(error);
        // }
        // const rechargeCustomers = customers.filter(
        //   // eslint-disable-next-line eqeqeq
        //   c => c.imPermanent == '1' && c.imUserStatus == '1',
        // );

        goTo(homePage, {
          screen: 'Chat',
          params: {
            // customerId:
            //   rechargeCustomers.length > 0
            //     ? rechargeCustomers[
            //         Math.floor(Math.random() * rechargeCustomers.length)
            //       ].imUserId
            //     : '',
            ts: Date.now(),
          },
        });
      },
    },
  ];
  const DISIGN_WEIDTH = 375;
  const computedSize = (num: number) => (num * screenWidth) / DISIGN_WEIDTH;
  const size = {
    computedL: computedSize(theme.paddingSize.l),
    computedS: computedSize(theme.paddingSize.s),
    computed60: computedSize(60),
    computed44: computedSize(44),
    computed40: computedSize(40),
    computed36: computedSize(36),
  };
  // const [token, setToken] = useState('');

  // useFocusEffect(
  //   useCallback(() => {
  //     const tokenSub = globalStore.tokenSubject.subscribe(_token => {
  //       setToken(_token || '');
  //     });
  //     return () => {
  //       tokenSub.unsubscribe();
  //     };
  //   }, []),
  // );
  return (
    <View
      style={[
        theme.flex.row,
        theme.flex.between,
        theme.flex.centerByCol,
        {
          margin: size.computedL,
        },
      ]}>
      {list.map((v, i) => {
        return (
          <div
            key={i}
            className="flex flex-col justify-center items-center gap-1 h-[4.875rem] relative"
            onClick={v.jumpHandler}>
            <LazyImage
              imageUrl={v.bgImgUrl}
              width={size.computed60}
              height={size.computed60}
              occupancy="transparent"
            />
            <div className="text-t1 text-center text-xs capitalize">
              {v.moduleName}
            </div>
          </div>
        );
      })}
    </View>
  );
};

export default HomeGoldArea;
